// extracted by mini-css-extract-plugin
export default {"pageLayout":"layout_pageLayout__8T9dA"};